'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var mobx = require('mobx');
var merge = _interopDefault(require('lodash.merge'));
var cloneDeep = _interopDefault(require('lodash.clonedeep'));
var isObject = _interopDefault(require('lodash.isobject'));

const reservedKeys = ['reset', 'extend', 'destroy'];
const checkReservedKeys = (obj) => {
    if (isObject(obj)) {
        Object.keys(obj).forEach((key) => {
            if (reservedKeys.includes(key)) {
                throw new TypeError(`property ${key} is reserved for storedObservable method`);
            }
        });
    }
};
function factory(storage) {
    return function storedObservable(key, defaultValue, autorunOpts = { delay: 500 }) {
        let fromStorage = storage.getItem(key);
        checkReservedKeys(defaultValue);
        checkReservedKeys(fromStorage);
        const defaultClone = Object.assign({}, cloneDeep(defaultValue), { reset() {
                disposeAutorun && disposeAutorun();
                mobx.set(obsVal, defaultValue);
                Object.keys(obsVal).forEach((key) => {
                    if (!defaultValue.hasOwnProperty(key) &&
                        !['reset', 'extend', 'destroy'].includes(key)) {
                        mobx.remove(obsVal, key);
                    }
                });
                establishAutorun();
            },
            extend(obj) {
                disposeAutorun && disposeAutorun();
                mobx.set(obsVal, obj);
                establishAutorun();
            },
            destroy() {
                disposeAutorun();
                storage.removeItem(key);
                window.removeEventListener('storage', propagateChangesToMemory);
            } });
        if (fromStorage) {
            merge(defaultClone, JSON.parse(fromStorage));
        }
        const obsVal = mobx.observable(defaultClone);
        let disposeAutorun;
        const establishAutorun = () => {
            disposeAutorun = mobx.autorun(() => {
                storage.setItem(key, JSON.stringify(mobx.toJS(obsVal)));
            }, autorunOpts);
        };
        establishAutorun();
        const propagateChangesToMemory = (e) => {
            if (e.key === key && e.newValue) {
                disposeAutorun();
                const newValue = JSON.parse(e.newValue);
                mobx.set(obsVal, newValue);
                establishAutorun();
            }
        };
        window.addEventListener('storage', propagateChangesToMemory);
        return obsVal;
    };
}
const localStored = factory(localStorage);
const sessionStored = factory(sessionStorage);

exports.localStored = localStored;
exports.sessionStored = sessionStored;



//////////////////
// WEBPACK FOOTER
// ./~/mobx-stored/dist/stored-observable.cjs.js
// module id = 3263
// module chunks = 0